import EndorsersView from './EndorsersView.vue';
import EndorserView from './EndorserView.vue';

export const endorsersRoutes = [
    {
        path: '/endorsers',
        name: 'Endorsers',
        component: EndorsersView,
        meta: {
            requiresAuth: true,
            accessId: 'endorsers',
        }
    },
    {
        path: '/endorsers/:id',
        name: 'EndorserView',
        component: EndorserView,
        meta: {
            requiresAuth: true,
            accessId: 'endorsers',
        }
    }
]
